<template>
  <v-container fluid class="pa-2">
<!--    <div v-if="isLoading" class="d-flex justify-center my-3">
      <v-progress-circular
          color="primary"
          indeterminate
          size="64"
      ></v-progress-circular>
    </div>-->      

    <!-- CONNECTIONS -->
    <div class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-12 col-lg-3 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0 text-break"><strong>{{ $t('cards.texts.wearablesTitle') }}</strong></v-card-title>
          <v-card-text class="py-0">
            <div>{{ $t('cards.texts.wearablesDescription') }}</div>
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-12 col-lg-9 ma-0 pa-2">
        <!-- CARD ACTIONS -->
        <v-card
            flat
            class="d-flex flex-column rounded-lg"
        >
          <v-card-text v-if="connectionLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap justify-end ma-0 pa-2" v-if="!connectionLoading">
            <div class="px-1">
              <v-btn
                  v-if="wefitterStatus.wefitterConnected"
                  depressed
                  color="primary"
                  class="rounded-lg"
                  :loading="deactivationLoading"
                  @click.prevent="deactivateWefitterProfile()"
              >
                {{ $t('buttons.deactivate') }}
              </v-btn>
              <v-btn
                  v-else-if="!wefitterStatus.wefitterConnected"
                  depressed
                  color="primary"
                  class="rounded-lg"
                  :loading="activationLoading"
                  @click.prevent="activateWefitterProfile()"
              >
                {{ $t('buttons.activate') }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
        <!-- CARD PARAMETERS -->
        <v-card
            flat
            class="d-flex flex-column rounded-lg mt-4"
        >
          <v-card-text class="d-flex flex-wrap ma-0 pa-2">
            <div v-for="(parameter, ndx) in parameters" :key="'param-' + ndx" class="ma-6 d-flex flex-column justify-center">
              <v-icon x-large color="primary">fal {{ parameter.icon }}</v-icon>
              <div class="font-weight-bold mt-3">{{ $t('labels.params.' + parameter.name) }}</div>
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <!-- DEVICES SECTION -->
    <div v-for="(connection, index) in connections" :key="'connection-' + index" class="d-flex flex-wrap align-stretch ma-0 pa-0">
      <!-- FIRST Column -->
      <div class="col-12 col-lg-3 ma-0 pa-2 pl-0">
        <v-card
            height="100%"
            flat
            color="transparent"
            class="rounded-lg"
        >
          <v-card-title class="pb-0 text-break ml-2"><strong>{{ connection['display_name'] }}</strong></v-card-title>
          <v-card-text class="d-flex flex-wrap ma-0 py-0">
<!--            <div>{{ $t('cards.texts.devices') }}</div>-->
          </v-card-text>
        </v-card>
      </div>

      <!-- SECOND Column -->
      <div class="col-12 col-lg-9 ma-0 pa-2">
        <v-card
            height="100%"
            flat
            class="d-flex flex-column rounded-lg"
            :class="connection.connected === 'CONNECTED' ? 'green lighten-5' : ''"
        >
          <v-card-text v-if="connectionLoading" class="d-flex justify-center align-center">
            <v-progress-circular
                color="primary"
                indeterminate
                size="64"
                class="my-3"
            ></v-progress-circular>
          </v-card-text>
          <v-card-text class="d-flex flex-wrap ma-0 pa-2" v-if="!connectionLoading">
            <div class="d-flex flex-wrap col-12 ma-0 pa-0 align-stretch">
              <div class="col-12 col-md-3 pa-2 d-flex justify-center">
                <!--<div><strong>Iphone</strong></div>-->
                <!--<div>{{ $t('cards.texts.vimeoDescription') }}</div>-->
                  <v-img
                    contain
                    max-height="150"
                    max-width="200"
                    :src="connection['img_url']"
                  ></v-img>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="d-flex flex-wrap col-12 col-md-5 pa-2">
                  <!--<strong>{{ $t('cards.texts.' + connection.connected) }}</strong>-->
                <!--<div class="ma-2 d-flex flex-column justify-center" v-if="bio.includes(connection['connection_slug'])"><v-chip color="primary" outlined x-small label>{{ $t('labels.bio-age') }}</v-chip></div>-->
                <template v-for="(parameter, ndx) in parameters">
                  <div :key="'param-' + ndx" class="ma-2 d-flex flex-column justify-center" v-if="parameter.connections.includes(connection['connection_slug'])">
                    <v-icon color="primary">fal {{ parameter.icon }}</v-icon>
                  </div>
                </template>
              </div>
              <div class="hidden-sm-and-down col-1 pa-2"><v-divider vertical></v-divider></div>
              <div class="col-12 col-md-2 py-2 px-0 d-flex flex-wrap justify-end">
                <div class="px-1">
                  <v-btn
                      depressed
                      color="primary"
                      class="rounded-lg"
                      @click.prevent="navigate(connection.url)"
                      :disabled="connection.connected === 'CONNECTED'"
                  >
                    {{ $t('buttons.connect') }}
                  </v-btn>
                </div>
                  <div class="px-1 pt-md-2">
                      <v-btn
                              depressed
                              color="primary"
                              outlined
                              class="rounded-lg"
                              @click.prevent="deleteConnection(connection['connection_slug'])"
                              :disabled="connection.connected === 'NOT_CONNECTED'"
                      >
                          {{ $t('buttons.disconnect') }}
                      </v-btn>
                  </div>
              </div>
<!--              <div class="hidden-md-and-up col-12 pa-2"><v-divider></v-divider></div>-->
            </div>
          </v-card-text>
        </v-card>
      </div>

    </div>

    <v-snackbar
        v-model="snack"
        :timeout="3000"
        :color="snackColor"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
            v-bind="attrs"
            icon
            @click="snack = false"
        >
          <v-icon>fal fa-xmark</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    
  </v-container>

</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-we-fitter",
  props: [],
  components: {
  },
  data() {
    return {
      isLoading: false,
      connections: [],
      parameters: [
        { name: 'bio-age', icon: 'fa-dna', connections: ['fitbit', 'garmin', 'google-fit', 'polar'] },
        { name: 'steps', icon: 'fa-shoe-prints', connections: ['fitbit', 'garmin', 'google-fit', 'polar'] },
        { name: 'distance', icon: 'fa-location-dot', connections: ['fitbit', 'strava', 'garmin', 'google-fit', 'polar'] },
        { name: 'calories', icon: 'fa-fire-flame', connections: ['fitbit', 'strava', 'garmin', 'google-fit', 'polar'] },
        { name: 'minutes', icon: 'fa-clock', connections: ['fitbit', 'strava', 'garmin', 'google-fit', 'polar'] },
        { name: 'workout-types', icon: 'fa-dumbbell', connections: ['fitbit', 'strava', 'garmin', 'google-fit', 'polar'] },
        { name: 'heart-rate', icon: 'fa-heart-pulse', connections: ['fitbit', 'strava', 'garmin', 'google-fit', 'polar'] },
        { name: 'stress', icon: 'fa-bolt', connections: ['garmin'] },
        { name: 'sleep', icon: 'fa-moon-stars', connections: ['fitbit', 'garmin', 'google-fit', 'polar'] }
      ],
      bio: ['fitbit', 'garmin', 'google-fit', 'polar'],
      snack: false,
      snackColor: '',
      snackText: '',
      connectionLoading: false,
      show: false,
      wefitterStatus: {},
      activationLoading: false,
      deactivationLoading: false,
    }
  },
  mounted() {
    this.fetchWefitterStatus()
  },
  
  methods: {
    async deactivateWefitterProfile(){
      const that = this
      that.deactivationLoading = true
      
      await api.connections.deleteWefitterProfile()

      await this.fetchWefitterStatus()
      
      that.deactivationLoading = false
    },

    async activateWefitterProfile(){
      const that = this
      that.activationLoading = true

      await api.connections.createWefitterProfile()

      await this.fetchWefitterStatus()

      that.activationLoading = false
    },
    
    async fetchWefitterStatus(){
      const that = this
      that.connectionLoading = true
      that.connections = []
      
      await api.connections.getWefitterStatus()
          .then((res) => {
            that.wefitterStatus = res.data
          })
      if (this.wefitterStatus.wefitterConnected){
        await this.fetchConnections()
      }
      that.connectionLoading = false
    },
    
    async fetchConnections() {
      const that = this
      that.connectionLoading = true

      await api.connections.getWefitterConnections()
          .then((res) => {
              that.connections = res.data
              that.connectionLoading = false
          })
    },

    async deleteConnection(connection) {
        const that = this
        //that.connectionLoading = true

        await api.connections.deleteConnection(connection)
            .then((res) => {
                that.connections = res.data
                //that.connectionLoading = false
            })
    },

    navigate(route){
      this.$root.$emit('m2h-loader-show')
      window.location.href = route
    },
    
    navigateExternal(route){
      this.$root.$emit('m2h-loader-show')
      window.open(route, '_blank')
    }
  }
}
</script>

<style scoped>

</style>